/**
 * @summary   Custom footer jQuery.
 *
 * @since     1.1.1
 * @requires  jquery.js
 */

(function($) {
    'use strict';

    /*--------------------------------------------------------------
    # Wait for the phone screens to finish animating first 
    # in the header, before introducing further transitions on 
    # the same element.
    --------------------------------------------------------------*/

    let $headerPhoneScreens = $( '.mm1-home__app-screenshot' );

    $headerPhoneScreens.on('inview.uk.scrollspy', function() {
        // Code to run when this element animates in / enter the viewport
        $headerPhoneScreens.removeClass( 'mm-transition-ready' );

        setTimeout(function() {
            $headerPhoneScreens.addClass( 'mm-transition-ready' );
        }, 700);
    });


    /*--------------------------------------------------------------
    # Tidio Live Chat
    --------------------------------------------------------------*/

    if ( $( 'body').hasClass( 'page-template-support' ) && $(location).attr('hash') === '#livechat' ) {
        $(window).on('load', function() {
            window.tidioChatApi.on('ready', function() {
                tidioChatApi.open();
            });
        });
    }


    /*--------------------------------------------------------------
    # UIKit switcher in Prop Picks DFS - Link the Rules tab 
    # to the FAQ page
    --------------------------------------------------------------*/
    if ( $( 'body').hasClass( 'page-template-prop-picks' ) ) {
        UIkit.util.on('.mm-no-switcher', 'click', function(e) {
            e.preventDefault();  // Blocks Switcher activation
            window.open(this.href, '_blank');  // Or just let browser handle: remove this line for same tab
        });
    }


    /*-----------------------------------------------------------------------------------*/
	/*	Scroll back to top
	/*-----------------------------------------------------------------------------------*/
	
	let $toTopBtn = $('.mm-back-to-top-btn');
    let threshold = 800;
    let scrolled  = 0;
    let past      = false;
    let $body     = $('body');
	
	$(window).on('scroll', function () {
        scrolled = $(window).scrollTop();
        past = scrolled > threshold;
      
        $body.toggleClass('mm-past-threshold', past);
    });
	
    
})( jQuery );